<template>
  <div class="product-slider">
    <slot />

    <VueCarousel
      :key="carouselKey"
      ref="carousel"
      v-bind="sliderSettings"
    >
      <VueSlide
        v-for="(product, index) in products"
        :key="product"
      >
        <ProductTile
          :product="product"
          :lazy="lazy || index > 2"
          class="product-slider__product"
          :show-cta="showCta"
          :linkable="productLinkable"
        />
      </VueSlide>

      <template #addons>
        <div
          v-if="showNavigation"
          class="carousel__navigation"
        >
          <VueNavigation>
            <template #prev>
              <IconArrow class="carousel__icon icon icon--arrow icon--arrow-left" />
            </template>
            <template #next>
              <IconArrow class="carousel__icon icon icon--arrow icon--arrow-right" />
            </template>
          </VueNavigation>
        </div>
      </template>
    </VueCarousel>
  </div>
</template>

<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'

const props = withDefaults(defineProps<{
  products: EsProduct[]
  lazy?: boolean
  showCta?: boolean
  productLinkable?: boolean
  customSettings?: any
}>(), {
  lazy: true,
  showCta: false,
  productLinkable: true,
  customSettings: {
    itemsToShow: 2,
    itemsToScroll: 1,
    snapAlign: 'start',
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3,
      },
      // 1024 and up
      1024: {
        itemsToShow: 4,
      },
    },
  },
})

const { settings } = useSliderSettings()
const sliderSettings = Object.assign({}, settings, props.customSettings)

const carousel = ref()
const carouselKey = ref(0)

const showNavigation = computed(() => {
  return props.products?.length > carousel.value?.data?.config?.itemsToShow
})

defineExpose({
  reinit: () => { carouselKey.value++ },
})
</script>

<style>
@import url("~layers/app/assets/css/vue3-carousel-nuxt.css");
@import url("~layers/app/components/Product/Slider.css");
</style>
